import React, { useState, useContext, useEffect } from "react";
import {
    Box,
    Button,
    Paper,
    Typography,
    TextField,
    Avatar,
    Grid,
    InputAdornment,
    Divider,
    Alert,
} from "@mui/material";
import { AccountBoxOutlined, VpnKeyOutlined } from "@mui/icons-material";
import GlobalContext from "../contexts/globalcontext";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";
const LOGIN_URL = "/auth/login";

const Login = () => {
    const navigate = useNavigate();

    const { setIsDarkMode, setAuth } = useContext(GlobalContext);
    const [username, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [errMsg, setErrMsg] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (username.toLowerCase() === "ryan") {
            setErrMsg("Ryan cannot login here.");
        } else {
            try {
                const response = await axios.post(
                    LOGIN_URL,
                    JSON.stringify({ username, password }),
                    {
                        headers: {
                            "Content-Type": "application/json",
                            // "Access-Control-Allow-Origin": "*",
                        },
                        withCredentials: true,
                    }
                );
                // console.log(response?.data);
                const accessToken = response?.data?.accessToken;
                setAuth({ username, password, accessToken });
                navigate("/");
            } catch (err) {
                if (!err?.response) {
                    setErrMsg("No Server Response");
                } else if (err.response?.status === 400) {
                    setErrMsg("Missing Username or Password");
                } else if (err.response?.status === 401) {
                    setErrMsg("Unauthorized");
                } else {
                    setErrMsg("Login Failed");
                }
            }
        }
    };

    useEffect(() => setIsDarkMode(false), [setIsDarkMode]);

    useEffect(() => {
        setErrMsg("");
    }, [username, password]);

    return (
        <Box
            sx={{
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                height: "100vh",
                backgroundColor: "black",
                backgroundImage: "url(/img/background.jpg)",
                backgroundSize: "100%",
            }}
        >
            <Paper
                sx={{
                    width: "320px",
                    height: "380px",
                    padding: "24px",
                    borderRadius: "20px",
                }}
                elevation={9}
            >
                <Box>
                    <form onSubmit={handleSubmit}>
                        <Grid container sx={{ marginBottom: "15px" }}>
                            <Grid item xs={3.5}>
                                <Avatar
                                    src="/img/login.png"
                                    sx={{ width: "50px", height: "50px" }}
                                />
                            </Grid>
                            <Grid item xs={8.5} sx={{ marginTop: "10px" }}>
                                <Typography
                                    variant="h5"
                                    sx={{ alignContent: "center" }}
                                >
                                    User Login
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider />
                        <br />
                        <TextField
                            required
                            autoFocus
                            id="username"
                            label="User Name"
                            // autoComplete="username"
                            autoComplete="off"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <AccountBoxOutlined />
                                    </InputAdornment>
                                ),
                            }}
                            defaultValue={username}
                            sx={{ width: "100%" }}
                            onChange={(e) => {
                                setUserName(e.target.value);
                            }}
                        />
                        <br />
                        <br />
                        <TextField
                            required
                            type="password"
                            id="password"
                            label="Password"
                            autoComplete="current-password"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <VpnKeyOutlined />
                                    </InputAdornment>
                                ),
                            }}
                            defaultValue={password}
                            sx={{ width: "100%" }}
                            onChange={(e) => {
                                setPassword(e.target.value);
                            }}
                        />
                        {errMsg ? (
                            <>
                                <Alert severity="error">{errMsg}</Alert>
                                {/* <Typography color="error">{errMsg}</Typography> */}
                            </>
                        ) : (
                            <>
                                <br />
                                <br />
                            </>
                        )}
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{ width: "100%", padding: 1.2 }}
                        >
                            Sign In
                        </Button>
                    </form>
                </Box>
                {/* <br />
                <br />
                <br />
                <Button
                    variant="contained"
                    onClick={() => setUserName("Jonathan")}
                    sx={{ width: "100%" }}
                >
                    Click to Set User
                </Button> */}
            </Paper>
        </Box>
    );
};

export default Login;
